module.exports = __webpack_public_path__ + "img/image3.5dbbe3c3.jpg";